// extracted by mini-css-extract-plugin
export default {"heading":"vu-z","signin":"wu-z","signupBtn":"xu-z","disabled":"yu-z"};